import { useEffect } from 'react'

export const useLoadingPage = () => {
  useEffect(() => {
    const loadingTcard = document.getElementById('loading-tcard')
    if (!loadingTcard) return

    // Hide the splash instantly under test. NODE_ENV covers the dev server;
    // VITE_E2E covers the production `vite preview` build the E2E suite serves
    // (where NODE_ENV is forced to "production"). The E2E webServer sets
    // VITE_E2E=true at build time (tests/e2e/playwright.config.ts).
    const isTestEnv =
      ['development', 'test'].includes(process.env.NODE_ENV as string) ||
      (import.meta.env as Record<string, string | undefined>).VITE_E2E === 'true'

    if (isTestEnv) {
      loadingTcard.style.display = 'none'
      return
    }

    setTimeout(() => {
      loadingTcard.classList.add('loading-tcard_slide-top')

      setTimeout(() => {
        loadingTcard.style.display = 'none'
      }, 500)
    }, 1200)
  }, [])
}
